// removed by extract-text-webpack-plugin
module.exports = {"Navigation":"src-components-Program-Navigation----Navigation-module---Navigation---3s-_P","Navigation__wrapper":"src-components-Program-Navigation----Navigation-module---Navigation__wrapper---i02lc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Program/Navigation/Navigation.module.scss
// module id = 735
// module chunks = 100691214015113